const RANK_SUFFIX = { 1: 'st', 2: 'nd', 3: 'rd' }

const withRankSuffix = (rank: number) => {
  return `${rank}${RANK_SUFFIX[rank] ?? 'th'}`
}

export default withRankSuffix
